export default __webpack_public_path__ + "static/media/skeim.99aff9b4.jpg";